<template>
  <AuthLayout>
    <div class="sign-in">
      <div class="sign-in__header">
        <div class="sign-in__header__title">Log in</div>
        <div class="sign-in__header__block">
          <a href="https://www.protosterminal.com/dashboard" class="sign-in__header__block__link">https://www.protosterminal.com/dashboard</a>
        </div>
      </div>
      <form @submit.prevent class="sign-in__form">
        <div class="sign-in__form__fullwidth">
          <BaseInput v-model="form.username" label="Email" required />
        </div>
        <div class="sign-in__form__fullwidth">
          <BaseInput v-model="form.password" type="password" label="Password" required />
        </div>
        <div class="sign-in__form__fullwidth">
          <BaseButton label="Sign in" @click="signinHandler" />
        </div>
      </form>
      <div class="sign-in__footer">
        <div class="sign-in__footer__text"> Not on Protos yet? </div>
        <router-link class="sign-in__footer__link" to="/sign-up">Get started</router-link>
      </div>
    </div>
  </AuthLayout>
</template>

<script>
import { mapActions } from 'vuex'
import { signIn } from "@/services/auth";
import AuthLayout from '@/layouts/AuthLayout'
import BaseInput from "@/components/ui/atoms/BaseInput";
import BaseButton from "@/components/ui/atoms/BaseButton";

export default {
  name: "SigninView",
  components: { BaseInput, BaseButton, AuthLayout },
  data() {
    return {
      form: {
        username: '',
        password: ''
      }
    }
  },
  methods: {
    ...mapActions({
      setIsLoading: 'setIsLoading',
      setSnackbarError: 'setSnackbarError'
    }),

    signinHandler() {
      this.setIsLoading(true)
      signIn(this.form)
          .then(() => this.redirectToFromUrl())
          .catch(({ message }) => this.setSnackbarError(message))
          .finally(() => this.setIsLoading(false))
    },
    redirectToFromUrl() {
      const params = new URLSearchParams(window.location.search)
      const from = params.get('from') ?? '/'
      this.$router.push(from)
    }
  }
}
</script>

<style lang="scss" scoped>
  .sign-in {
    max-width: 620px;
    min-width: 500px;

    &__header {

      &__title {
        font-weight: 700;
        font-size: 2rem;
        padding: 1rem 0;
        text-align: start;
      }

      &__block {
        color: #4f7775;
        size: 1rem;
        text-align: start;
        display: flex;
        align-items: center;

        &__link {
          color: #4f7775;
          size: 1rem;
        }

        &__img {
          stroke: #4f7775;
          color: #4f7775;
          height: 1rem;
          width: 1rem;
          margin-right: 0.5rem;
        }

      }

    }

    &__form {

      &__fullwidth {
        margin-top: 2rem;
      }

    }

    &__footer {
      display: flex;
      padding-top: 2rem;

      &__text {
        font-weight: 600;
        font-size: 1.125rem;
        margin-right: 0.5rem;
      }

      &__link {
        font-weight: 600;
        font-size: 1.125rem;
        color: blueviolet;
      }

    }

  }

  @media (max-width: 786px) {
    .sign-in {
      max-width: 100%;
      min-width: 100%;
    }
  }
</style>
